import { createTheme } from '@mui/material'
const theme = createTheme({
  palette: {
    primary: {
      main: '#2B479E',
    },
  },
})

export default theme
